/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FormattedMessage } from 'react-intl'
import { Table } from '@mantine/core'
import SelectionToggle from '../../../../../client/js/components/selection/SelectionToggle'
import LeaseTemplateListItem from './LeaseTemplateListItem'
import NoData from '../../../../../client/js/components/NoData'

export type LeaseTemplateListProps = {
  items: LeaseTemplate[]
}

function LeaseTemplateList (props: LeaseTemplateListProps) {
  const { items } = props
  return (
    <Table highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th w={50}>
            <SelectionToggle />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="template_name"
              defaultMessage="Nom du modèle"
            />
          </Table.Th>
          <Table.Th w={150}>
            <FormattedMessage
              id="furnishing"
              defaultMessage="Ameublement"
            />
          </Table.Th>
          <Table.Th w={150}>
            <FormattedMessage
              id="management"
              defaultMessage="Gestion"
            />
          </Table.Th>
          <Table.Th w={120}>
            <FormattedMessage
              id="lease_duration"
              defaultMessage="Durée du bail"
            />
          </Table.Th>
          <Table.Th w={130}>
            <FormattedMessage
              id="notice_duration"
              defaultMessage="Durée du préavis"
            />
          </Table.Th>
          <Table.Td />
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {items.length > 0
          ? items.map((item) => (
            <LeaseTemplateListItem
              item={item}
              key={item.id}
            />
          ))
          : <Table.Tr>
            <Table.Td colSpan={9}>
              <NoData />
            </Table.Td>
          </Table.Tr>
        }
      </Table.Tbody>
    </Table>
  )
}

export default LeaseTemplateList
